import moment from 'moment';
import Validations, { isFieldValid, Patterns, validatePattern } from '../../../../commons/validations';
import isEmpty from 'lodash/isEmpty';

function isEmailValid ({ value, required }) {

    let result = isFieldValid({
        rules: {
            ...Validations.email,
            required,
        },
        value,
    });

    if (!result) {
        result = validatePattern(Patterns.ipEmail, value);
    }

    return result;
}

function isValidRequired ({ value, required }) {
    return isFieldValid({
        rules: {
            ...Validations.genericRequired,
            required, //uncomment on actual
        },
        value,
    })
}

function isSelectValid ({ value, required}) {
    if (required) {
        if (value === '-' || !value) {
            return false;
        }
    }
    return true;
}

function isMobileValid ({ value, required }) {

    const isValid =  isFieldValid({
        rules: {
            ...Validations.phone,
            required, // uncomment on actual
        },
        value,
    });

    if (!isValid && !required && value.length <= 3) {
        return true;
    }

    return isValid;
}

function isDOBValid (p) {
    const {
        value,
        required,
        widget,
    } = p;

    if (required) {
        if (!isValidDate(value)) {
            return false;
        }
        const passed = getYearsPassed(value);
        if (widget?.requiredAge === 0) {
            return true;
        }
        
        if (passed < widget?.requiredAge) {
            return false;
        }
    }
    return true;
}

const validators = {
    email: isEmailValid,
    first_name: isValidRequired,
    last_name: isValidRequired,
    mobile: isMobileValid,
    zip: isValidRequired,
    dob: isDOBValid,
    age_group: isSelectValid,
    parentConsentOn: isSelectValid,
    parentEmail: isEmailValid,
};

export function getYearsPassed(dateString) {
    const parsedDate = moment(dateString, 'YYYY-MM-DD');
    if (!parsedDate.isValid()) {
      return 0;
    }

    const yearsPassed = moment().diff(parsedDate, 'years');
    return yearsPassed;
}

function validateFields () {
    const appStore = this.env.appStore;
    // const customFields = appStore.widget?.custom_fields;
    const regFields = appStore.widget?.registration_fields;
    function isRequired (fld) {
        if (fld === 'first_name' || fld === 'last_name') {
            return regFields['name'] === 1 || regFields[fld] === 1;
        }

        // this DATA mixed up dob, dateOfBirth and age group is here since the old legacy data.
        if (fld === 'dob') {
            return regFields.dateOfBirth === 1;
        }

        if (fld === 'age_group') {
            return regFields.dob === 1;
        }

        if (fld === 'parentConsentOn') {
            return regFields.parentalConsentAge === 1;
        }

        return regFields[fld] === 1;
    }

    let errs =  {};
    for (let fld in this.subscribersFields) {
        const value = this.subscribersFields[fld];
        const isValid = validators[fld];
        if (this.touchedFields[fld] && typeof isValid === 'function') {
            const req = isRequired(fld);
            const valid = isValid({
                store: appStore,
                widget: appStore.widget,
                field: fld,
                required: req,
                value });
            if (!valid) {
                errs[fld] = true;
            }
        }
    }

    if (this.subscribersFields?.parentConsentOn && this.subscribersFields?.parentConsentOn.toLowerCase() !== 'no') {
        delete errs.parentEmail;
    }

    errs = {
        ...errs,
        ...this.validateCustomFields(),
        ...this.validateOptinsFields(),
    };

    // console.log('validateFields(): errors: ', errs);
    this.setFieldErrors(errs);
}

export function validateCustomFields () {
    const errs =  {};
    let pConsentValue = '';
    for (let fld in this.customValues) {
        const value = this.customValues[fld];
        const req = this.isCustomFieldRequired(fld);
        const field = this.getCustomField(fld);
        if (fld === 'parentEmail') {
            const valid = isEmailValid({ value, required: true });
            if (!valid && pConsentValue.toLowerCase() === 'no') {
                errs[fld] = true;
            }
            // it means it is parentEmail
            continue;
        }

        if (field.type === 'parentalconsent') {
            pConsentValue = value;
        }

        if (field.visible === false) {
            continue;
        } 

        const valid = isCustomFieldValid({ value, field, fieldName: fld });
        if (req && !valid) {
            errs[fld] = true;
        }
    }
    this.customParentConsentValue = pConsentValue;
    return errs;
}

function isValidDate(dateString) {
    const dateFormat = 'YYYY-MM-DD';
    const minDate = moment('1905-01-01', dateFormat);
    const parsedDate = moment(dateString, dateFormat, true); // Strict parsing
  
    if (!parsedDate.isValid()) {
      return false; // Invalid format or date
    }
  
    return parsedDate.isSameOrAfter(minDate); // Check if date is on or after the minimum date
}

function isCustomFieldValid ({  value, field }) {
    if (isEmpty(field)) {
        return true;
    }

    if (field.type === 'dropdown') {
        if (value === '-' || !value) {
            return false;
        }
    } else if (field.type === 'datepicker') {
        return isValidDate(value);
    } else {
        if (!value) {
            return false;
        }
    }
    return true;
}

export function validateOptinsFields () {
    const errs =  {};
    return errs;
}

export default validateFields;
